import { DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const ReminderDialogHeader = () => {
  return (
    <DialogHeader>
      <DialogTitle className="flex items-center gap-2">
        Schedule LinkedIn Post
      </DialogTitle>
      <p className="text-sm text-muted-foreground mt-2">
        Choose when you'd like your content to be automatically posted to LinkedIn.
      </p>
    </DialogHeader>
  );
};